module.exports = __webpack_public_path__ + "img/animal.46fac73a.svg";